import qs from 'query-string';

import { onboarding } from '@services';

interface IAssignUsersToRequest {
  user: {
    name: string;
    avatar: string;
    email: string;
    id: string;
    authorId: string;
  };
  threadId?: string;
}

const assignUsersToRequest = async ({
  user,
  threadId,
}: IAssignUsersToRequest): Promise<void> => {
  const query = {
    threadId,
  };

  const queryString = qs.stringify(query);

  await onboarding.patch<IAssignUsersToRequest>(
    `/api/v1/assets/irequest/assign?${queryString}`,
    { user },
  );
};

const unassignUsersFromRequest = async ({ threadId }: { threadId: string }) => {
  await onboarding.patch<{ threadId: string }>(
    `/api/v1/assets/irequest/unassign?threadId=${threadId}`,
  );
};

export { assignUsersToRequest, unassignUsersFromRequest };
